module.exports = require("copy-webpack-plugin");